import React from 'react'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from '../../../PageWrapper'
import BreadcrumbNav from '../../../components/Breadcrumbs'
import PaymentBulkUpload from '../components/PaymentBulkUpload'
import { FINANCE_PATH } from '../constants'

const { Content } = Layout

export default function PaymentBulkUploadPage() {
  return (
    <PageWrapper>
      <Page
        title="Payment Bulk File Upload"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: FINANCE_PATH },
              { title: 'Payment Bulk File Upload' },
            ]}
          />
        }
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            <PaymentBulkUpload />
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
